import type { GetB2bOrderDetailsResponse } from '@Common/types/b2b/orders';

export const b2bOrdersTranslations = {
  sides: {
    buy: 'Achat',
    sell: 'Vente',
  } satisfies Record<GetB2bOrderDetailsResponse['side'], string>,
  status: {
    pending: 'En cours',
    filled: 'Éxécuté',
    shares_canceled: 'Shares annulé',
    rejected: 'Rejeté',
    shares_new: 'Shares Nouveau',
    pending_funds: 'En attente de fonds',
    shares_pending_arbitrage: "Shares en attente d'arbitrage",
    shares_pending_company: "Shares en attente de l'entreprise",
    shares_pending_campaign: 'Shares en attente de opération',
    shares_pending_reallocation: 'Shares en attente de réallocation',
    shares_pending_approval: "Shares en attente d'approbation",
    shares_pending_cutoff_period: 'Shares en attente de période de clôture',
    shares_pending_blocked_instrument: "Shares en attente d'instrument bloqué",
    shares_pending_triggered_order: "Shares en attente du déclenchement de l'ordre",
    shares_pending_scheduling: 'Shares en attente de planification',
  } satisfies Record<GetB2bOrderDetailsResponse['status'], string>,
  operation: {
    subscription: 'Souscription',
    arbitrage: 'Arbitrage',
    redemption: 'Rédemption',
    liquidation: 'Liquidation',
  } satisfies Record<GetB2bOrderDetailsResponse['operation'], string>,
  oddo_status: {
    sent: 'Envoyé',
    acknowledged: 'Signalé',
    confirmed: 'Confirmé',
    rejected: 'Rejeté',
  } satisfies Record<Exclude<GetB2bOrderDetailsResponse['oddo_status'], null>, string>,
  cancellation_initiator: {
    user: 'Utilisateur',
    bo: 'Back office',
    system: 'Système',
  } satisfies Record<Exclude<GetB2bOrderDetailsResponse['cancellation_initiator'], null>, string>,
  cancellation_reason: {
    user_action: "Annulé par l'utilisateur.",
    shares_agent: 'Annulé par un agent Shares — consulter le journal des modifications.',
    error: 'Annulé par le broker ou suite à une erreur système inattendue.',
    compliance_verification_failed:
      "L'utilisateur a échoué à une vérification (identité / correspondance de nom).",
    failed_deposit: 'Le financement a échoué.',
    insufficient_balance: 'Solde insuffisant sur le compte.',
    expired: "L'ordre a expiré.",
    skipped: 'Exécution récurrente ignorée pour cet ordre.',
    order_not_tradable: "L'instrument n'était pas négociable au moment de l'exécution.",
    sof_task_rejected: "La tâche de vérification de l'origine des fonds a été rejetée.",
  } satisfies Record<Exclude<GetB2bOrderDetailsResponse['cancellation_reason'], null>, string>,
};
